<template>
  <!-- 文件列表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="图层名字">
              <a-input v-model="query.layerName" placeholder="请输入图层名字" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="图层编码">
              <a-input v-model="query.layerCode" placeholder="请输入图层编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
        <a-divider type="vertical" />
        <a @click="addOrUpdateHandle(record.id,'copy')" v-action:edit>复制</a>
      </span>
      <div
        slot="stylePreview"
        slot-scope="text, record"
        v-if="record.style"
        style="margin-left:75px"
      >
        <div
          v-if="record.style.styleType===1"
          style="width:50px;height:50px;border-radius:4px;background:#ECEFF3;display:flex;justify-content: center;align-items: center;"
        >
          <img :src="record.style.styleValue" width="50" height="50" alt="加载失败" />
        </div>
        <div v-if="record.style.styleType===2" style="width:50px;height:50px;">
          <svg style="margin-left: -10px;width:100%; height:50%">
            <g fill="none" :stroke="record.style.styleValue | useStyle1">
              <path
                :stroke-width="record.style.styleValue | useStyle2"
                d="M0 15 l65 0"
                :stroke-dasharray="record.style.styleValue | useStyle3"
              />
            </g>
          </svg>
          <svg style="margin-left: -10px;width:100%; height:50%" viewBox="-3 2 22 3">
            <g fill="none" :stroke="record.style.styleValue | useStyle1">
              <path d="M3,5 l1,-3 l1,3" :stroke-linejoin="record.style.styleValue | useStyle4" />
            </g>
          </svg>
        </div>
        <div
          v-if="record.style.styleType===3"
          style="width:50px;height:50px;"
          :style="record.style.styleValue | useStyle"
        ></div>
      </div>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model class="log-form" ref="addOrUpdateForm" :model="addOrUpdateForm" :rules="rules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="图层名称"
          prop="layerName"
        >
          <a-input placeholder="名称" v-model="addOrUpdateForm.layerName" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="图层编码"
          prop="layerCode"
        >
          <a-input
            placeholder="图层编码"
            v-model="addOrUpdateForm.layerCode"
          />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="图层地址"
          prop="layerUrl"
        >
          <a-input placeholder="图层地址" v-model="addOrUpdateForm.layerUrl" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="工作区"
          prop="workspace"
        >
          <a-input placeholder="工作区" v-model="addOrUpdateForm.workspace" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="工作区图层名称"
          prop="dataSource"
        >
          <a-input placeholder="工作区图层名称" v-model="addOrUpdateForm.dataSource" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="过滤条件"
          prop="dataFilteringCondition"
        >
          <a-textarea
            :rows="5"
            placeholder="过滤条件,例如is_deleted = false <#if tenantId??>and tenant_id = ${tenantId}</#if>"
            v-model="addOrUpdateForm.dataFilteringCondition"
          />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="图层源数据表名称"
          prop="sourceTableName"
        >
          <a-select v-model="addOrUpdateForm.sourceTableName" placeholder="请选择图层源数据表名称">
            <a-select-option
              v-for="item in layerSourceTableNameList"
              :key="item.id"
              :value="item.dictValue"
            >{{ item.dictName }}({{ item.dictValue }})</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否默认加载"
          prop="defaultLoad"
        >
          <a-switch
            default-checked
            checked-children="是"
            un-checked-children="否"
            v-model="addOrUpdateForm.defaultLoad"
          ></a-switch>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否显示图例"
          prop="showLegend"
        >
          <a-switch
            default-checked
            checked-children="是"
            un-checked-children="否"
            v-model="addOrUpdateForm.showLegend"
          ></a-switch>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="样式"
          v-if="addOrUpdateForm.style"
        >
          <span @click="selectStyle">
            <div v-if="addOrUpdateForm.style">
              <div v-if="addOrUpdateForm.style.styleType === 1" class="style-box">
                <img
                  v-if="addOrUpdateForm.style.styleValue"
                  :src="addOrUpdateForm.style.styleValue"
                  alt="avatar"
                  width="50px"
                  height="50px"
                />
              </div>
              <div v-if="addOrUpdateForm.style.styleType === 2" class="style-box">
                <div class="svg-box">
                  <svg>
                    <g fill="none" :stroke="addOrUpdateForm.style.styleValue | useStyle1">
                      <path
                        :stroke-width="addOrUpdateForm.style.styleValue | useStyle2"
                        d="M5 10 l30 0"
                        :stroke-dasharray="addOrUpdateForm.style.styleValue | useStyle3"
                      />
                    </g>
                  </svg>
                </div>
                <div class="svg-box">
                  <svg viewBox="2 0 10 5">
                    <path
                      d="M6,5 l1,-3 l1,3"
                      :stroke="addOrUpdateForm.style.styleValue | useStyle1"
                      fill="none"
                      :stroke-linejoin="addOrUpdateForm.style.styleValue | useStyle4"
                    />
                  </svg>
                </div>
              </div>
              <div
                v-if="addOrUpdateForm.style.styleType===3"
                style="width:50px;height:50px;"
                :style="addOrUpdateForm.style.styleValue | useStyle"
              ></div>
            </div>
          </span>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
          <a-input placeholder="备注" v-model="addOrUpdateForm.remark" />
        </a-form-model-item>
      </a-form-model>
      <a-modal
        title="选择样式"
        style="top: 20px"
        :width="600"
        :afterClose="selectStyleClose"
        v-model="styleDialog"
        @ok="selectStyleHandleOk"
        @cancel="selectStyleCancel"
      >
        <div class="iconOrStyleBox">
          <div
            ref="choStyle"
            class="icon-box"
            :style="styleIndex === i ? selectStyleIndex : ''"
            v-for="(item,i) in styleList"
            :key="i"
            @click="chooseStyle(item,i)"
          >
            <div v-if="item.styleType==1" style="background: #C0C4CC">
              <img
                v-if="item.styleValue"
                :src="item.styleValue"
                width="50"
                height="50"
                alt="avatar"
              />
            </div>
            <div
              v-else-if="item.styleType === 3"
              class="style-box"
              :style="item.styleValue | useStyle"
            ></div>
            <div v-else-if="item.styleType === 2" class="style-box">
              <div class="svg-box">
                <svg>
                  <g fill="none" :stroke="item.styleValue | useStyle1">
                    <path
                      :stroke-width="item.styleValue | useStyle2"
                      d="M5 10 l30 0"
                      :stroke-dasharray="item.styleValue | useStyle3"
                    />
                  </g>
                </svg>
              </div>
              <div class="svg-box">
                <svg viewBox="2 0 10 5">
                  <path
                    d="M6,5 l1,-3 l1,3"
                    :stroke="item.styleValue | useStyle1"
                    fill="none"
                    :stroke-linejoin="item.styleValue | useStyle4"
                  />
                </svg>
              </div>
            </div>
            <div class="styleTxt" :title="item.styleName">{{ item.styleName }}</div>
          </div>
        </div>

        <div>
          <!-- :page-size="styleQuery.limit"
            :pager-count="5"
            layout="total, prev, pager, next"
          :current-page.sync="currentPage"-->
          <a-pagination
            :total="total"
            :show-total="total => `共 ${total} 条`"
            :page-size="16"
            :default-current="1"
            v-model="currentPage"
            @change="handleStyleChange"
          ></a-pagination>

          <!-- <a-button type="primary" @click="selectStyleClose">{{ $t('confirm') }}</el-button> -->
        </div>
      </a-modal>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { listChildrenByDictCode } from '@/api/manage'

const columns = [
  {
    title: '名称',
    dataIndex: 'layerName'
  },
  {
    title: '编码',
    dataIndex: 'layerCode'
  },
  {
    title: '地址',
    dataIndex: 'layerUrl',
    ellipsis: true
  },
  {
    title: '工作区',
    dataIndex: 'workspace',
    ellipsis: true
  },
  {
    title: '工作区图层',
    dataIndex: 'dataSource',
    ellipsis: true
  },
  {
    title: '样式预览',
    width: 200,
    align: 'center',
    scopedSlots: { customRender: 'stylePreview' }
  },
  {
    title: '过滤条件',
    dataIndex: 'showFilterCondition',
    ellipsis: true
  },
  {
    title: '备注',
    dataIndex: 'remark',
    ellipsis: true
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },

  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data () {
    return {
      total: 0,
      currentPage: 1,
      styleQuery: {
        limit: 16,
        page: 1
      },
      selectStyleIndex: {
        border: '1px solid #999',
        borderRadius: '4px',
        boxShadow: '0px 0px 3px 0px'
      },
      styleIndex: '',
      styleList: [],
      styleDialog: false,
      addOrUpdateForm: {
        defaultLoad: false, // 是否默认加载
        showLegend: true, // 是否显示图例
        styleId: '',
        layerName: '',
        remark: '',
        dataFilteringCondition: '',
        layerUrl: '',
        layerCode: '',
        dataSource: '',
        sourceTableName: '',
        workspace: '', // 工作区
        style: {
          styleName: '',
          styleType: 1,
          styleValue: ''
        }
      },
      currentId: '',
      queryUrl: '/manager/base-layer/page',
      deleteUrl: '/manager/base-layer',
      addOrUpdateUrl: '/manager/base-layer',
      queryOneUrl: '/manager/base-layer',
      query: {
        legendName: ''
      },
      layerSourceTableNameList: [], // 图层数据源表名集合
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns
    }
  },

  created () {
    this.listLayerSourceTableNameList()
  },
  computed: {
    rules () {
      return {
        layerName: [{ required: true, message: '请输入图层名字' }],
        layerCode: [{ required: true, message: '请输入图层编码' }],
        layerUrl: [{ required: true, message: '请输入图层路径' }],
        workspace: [{ required: true, message: '请输入工作区' }],
        dataSource: [{ required: true, message: '请输入数据源(geoserver工作区间:图层名称)' }]
      }
    }
  },
  filters: {
    useStyle: value => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `background:${arrs[0]};border:${arrs[1]} ${arrs[3]}px solid; opacity:${arrs[2]}; width:50px`
    },
    useStyle1: value => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[1]}`
    },
    useStyle2: value => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[0]}`
    },
    useStyle3: value => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[2]}`
    },
    useStyle4: value => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[3]}`
    }
  },
  methods: {
    // 页面改变
    handleStyleChange (current, pageSize) {
      this.styleQuery.page = current
      this.styleQuery.limit = pageSize
      this.selectStyle()
    },
    // 选择样式完全关闭后
    selectStyleClose () {
      this.styleDialog = false
      this.styleQuery.page = 1
      this.currentPage = 1
      this.styleIndex = ''
    },
    // 选择样式
    chooseStyle (style, index) {
      this.styleIndex = index
      this.addOrUpdateForm.style.styleType = style.styleType
      this.addOrUpdateForm.style.styleValue = style.styleValue
      this.addOrUpdateForm.styleId = style.id
    },
    selectStyleHandleOk () {
      this.styleDialog = false
    },
    selectStyleCancel () {},
    // 选择样式按钮
    selectStyle () {
      this.styleDialog = true
      const params = this.styleQuery
      this.$http.get('/manager/base-style/page', { params }).then(res => {
        
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.styleList = res.data.list
        this.total = res.data.total ? parseInt(res.data.total) : 0
      })
    },
    detailInfo (record) {
      this.detailForm = { ...record }
    },
    handleOk (e) {
      e.preventDefault()

      this.$refs.addOrUpdateForm.validate(valid => {
        if (valid) {
          const params = { id: this.currentId, ...this.addOrUpdateForm }

          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then(res => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.$refs.addOrUpdateForm.resetFields()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    // 编辑新增
    addOrUpdateHandle (id, copy) {
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.addOrUpdateForm = {

        defaultLoad: false, // 是否默认加载
        showLegend: true,
        styleId: '',
        layerName: '',
        remark: '',
        dataFilteringCondition: '',
        layerUrl: '',
        layerCode: '',
        dataSource: '',
        sourceTableName: '',
        workspace: '', // 工作区
        style: {
          styleName: '',
          styleType: 1,
          styleValue: ''
        }

        }
        // this.clearStyle()
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.getInfo(copy)
          if (copy) {
            this.addOrUpdateForm.id = ''
            this.currentId = ''
          }
        }
      })
    },
    getInfo (copy) {
      this.$http
        .get(`/manager/base-layer/${this.currentId}`)
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.addOrUpdateForm = {
            ...this.addOrUpdateForm,
            ...res.data
          }
          if (copy) {
            this.addOrUpdateForm.id = ''
          }
          this.addOrUpdateForm.style === null
            ? (this.addOrUpdateForm.style = {
                styleName: '',
                styleType: 1,
                styleValue: ''
              })
            : ''
          // if (this.addOrUpdateForm.styleType === 3) {
          //   let arr2 = this.addOrUpdateForm.styleValue
          //   arr2 = arr2.split(';')
          //   const arrs = []
          //   arr2.forEach(item => {
          //     arrs.push(item.split(':')[1])
          //   })
          //   this.fillcolor = arrs[0]
          //   this.strokecolor = arrs[1].split(' ')[0]
          //   this.fillopacity = arrs[2]
          //   this.strokewidth = arrs[3].replace('px', '')
          // } else if (this.addOrUpdateForm.styleType === 2) {
          //   let arr3 = this.addOrUpdateForm.styleValue
          //   arr3 = arr3.split(';')
          //   const arrs = []
          //   arr3.forEach(item => {
          //     arrs.push(item.split(':')[1])
          //   })
          //   this.borderSize = arrs[0]
          //   this.borderColor = arrs[1]
          //   this.dasharray = arrs[2]
          // }
        })
        .catch(() => {})
    },
    handleCancel () {},
    listLayerSourceTableNameList () {
      listChildrenByDictCode('LAYER_SOURCE_TABLE_NAME').then(({ data }) => {
        this.layerSourceTableNameList = data
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.style-box {
  width: 50px;
  height: 50px;
  display: inline-block;
  background: #c0c4cc;
  cursor: pointer;
}
.style-box:active {
  box-shadow: 2px 2px 5px 2px #c58b8b !important;
}
.iconOrStyleBox {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}

.icon-box {
  margin: 5px 7px;
  width: 50px;
  text-align: center;
  cursor: pointer;
}
.styleTxt {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.set-box svg {
  height: 100%;
  width: 100%;
}
.svg-box {
  height: 50%;
}
</style>
